import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const KonturFocus = (props: TIconProps): ReactElement => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      width="24"
      height="24"
      rx="4"
      fill="hsl(from hsl(14 87% 55%) h s 50%)"
    />
    <path d="M7 8H17V10H7V8Z" fill="white" />
    <path d="M7 11H17V13H7V11Z" fill="white" />
    <path d="M7 14H14V16H7V14Z" fill="white" />
    <circle cx="17" cy="15" r="2" fill="white" />
  </svg>
);
